export const LOCALSTORAGE_TOKEN = 'LOCALSTORAGE_TOKEN'
export const LOCALSTORAGE_USER = 'LOCALSTORAGE_USER'
